// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"MenuShareProfile_iconContainer__b8TRT"};